
const setLtcat = (context,ltcat) => {
	context.commit('SET_LTCAT', ltcat);
}

export{
	setLtcat
}



// WEBPACK FOOTER //
// ./src/store/ltcat/actions.js